<template>
  <v-container grid-list-md>
    <v-snackbar
      :timeout="2000"
      :top="true"
      v-model="successSnack"
      color="success"
    >
      <span>Udało się!</span>
      <!--<v-btn dark flat @click.native="redirectToMainView">Przejdź dalej</v-btn>-->
      <v-btn flat @click.native="successSnack = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-dialog v-model="dialog" max-width="500px" v-if="drinkProperties(currentClickedDrink.drinkId)">

      <v-card>
        <v-card-title>
          <span class="cutString headline" v-if="drinkProperties(currentClickedDrink.drinkId)">({{currentClickedDrink.size}}ml) {{drinkProperties(currentClickedDrink.drinkId).name}}</span>

        </v-card-title>
        <v-card-text>

          <v-text-field
            label="Pojemność napoju"
            v-model.number="currentClickedDrink.size"
            type="number"
            min="0"
            max="100000"
            required
          ></v-text-field>
          <small class="grey--text" v-show="!drinkProperties(currentClickedDrink.drinkId).active">Szablon tego napoju został usunięty.</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="deleteEditDialog">Usuń</v-btn>
          <v-btn flat color="primary" @click="saveEditDialog">Zapisz</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-text class="px-0">


            <v-container grid-list-md text-xs-center>
              <transition-group name="list">
                <v-layout row wrap v-for="(drink, id) in drunkHistoryLast" :key="drink.id">
                  <!--<div >-->

                  <v-flex xs4 class="pb-0 mb-0">
                    <v-btn outline block color="indigo" small disabled @click.native="openEditDialog(drink)">
                      <!--<v-icon>{{id}}</v-icon>-->
                      <span>{{getOnlyTime(drink.dateTime)}}</span>
                    </v-btn>
                  </v-flex>
                  <v-flex xs8 class="pb-0 mb-0">
                    <v-btn outline block color="indigo" @click.native="openEditDialog(drink)">
                      <v-icon>local_drink</v-icon>
                      <span class="cutString">({{drink.size}}ml) {{drinkProperties(drink.drinkId).name}}</span>
                    </v-btn>
                  </v-flex>
                  <!--<v-chip close @click.native="openEditDialog(drink)">-->
                  <!--<v-avatar class="teal">-->
                  <!--<v-icon>local_drink</v-icon>-->
                  <!--</v-avatar>-->
                  <!--</v-chip>-->
                  <!--</div>-->
                </v-layout>
                <v-layout row wrap v-if="drunkHistory.length > drunkHistoryLast.length" key="last">
                  <v-flex xs4 class="pb-0 mb-0">
                    <v-btn outline block color="indigo" small disabled>
                      <!--<v-icon>{{id}}</v-icon>-->
                      <span>...</span>
                    </v-btn>
                  </v-flex>
                  <v-flex xs8 class="pb-0 mb-0">
                    <v-btn outline block color="indigo" @click="goToHistory">
                      <!--<v-icon>local_drink</v-icon>-->
                      <span>...</span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </transition-group>

            </v-container>

            <!--<div v-if="drunkHistory.length > drunkHistoryLast.length">-->
            <!--<v-btn outline color="indigo" disabled @click.native="openEditDialog(drink)">-->
            <!--&lt;!&ndash;<v-icon>{{id}}</v-icon>&ndash;&gt;-->
            <!--<span>{{drunkHistoryLast.length+1}}</span>-->
            <!--</v-btn>-->
            <!--<v-btn outline color="indigo" disabled @click.native="openEditDialog(drink)">-->
            <!--<v-icon>local_drink</v-icon>-->
            <!--<span>...</span>-->
            <!--</v-btn>-->

            <!--</div>-->
            <!--</div>-->
            <!--<v-btn v-for="(drink, id) in drunkHistory" :key="id">-->
            <!--<v-icon>local_drink</v-icon>-->
            <!--<span>{{drink.size}}</span>-->
            <!--</v-btn>-->
            <!--</v-flex>-->
            <!--</v-layout>-->
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import lodash from 'lodash';

  export default {
    name: 'drunkDrinks',
    props: ['drunkHistory', 'availableDrinks', 'showLessHistory'],
    data() {
      return {
        dialog: false,
        currentClickedDrink: {},
        successSnack: false,
        // _drunkHistory: []
      }
    },
    created() {
      // this._drunkHistory = this.drunkHistory;
      console.log("Less", this.showLessHistory)
    },
    computed: {
      drunkHistoryLast() {
        if (this.showLessHistory) {
          return _.orderBy(this.drunkHistory
            , 'id', 'desc').slice(0, 4)
        } else {
          return _.orderBy(this.drunkHistory
            , 'id', 'desc')
        }

      },


    },
    methods: {
      getOnlyTime(date) {
        let parseDate = new Date(date);
        let h = (parseDate.getHours() < 10 ? '0' : '') + parseDate.getHours();
        let m = (parseDate.getMinutes() < 10 ? '0' : '') + parseDate.getMinutes();
        return `${h}:${m}`
      },
      drinkProperties(id) {
        // console.log("=>", id);
        return this.availableDrinks.find((obj) => {
          // console.log("->", obj);
          return obj.id == id;
        });


      },
      openEditDialog(drink) {
        this.currentClickedDrink = Object.assign({}, drink);
        this.dialog = true;
        // console.log("Edit ", this.currentClickedDrink)
      },
      saveEditDialog() {
        this.dialog = false;
        this.$emit('saveEditDialog', {id: this.currentClickedDrink.id, newSize: parseInt(this.currentClickedDrink.size)});
        this.successSnack = true;

      },
      deleteEditDialog() {
        this.dialog = false;
        this.$emit('deleteEditDialog', this.currentClickedDrink.id);
        this.successSnack = true;

      },
      goToHistory() {
        this.$router.push({name: 'fullHistory'});

      }
    }
  }
</script>

<style scoped>

  .cutString {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .list-item {
    display: inline-block;
    margin-right: 10px;
  }

  .list-enter-active, .list-leave-active {
    transition: all .5s;
  }

  .list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */
  {
    opacity: 0;
    transform: translateX(30px);
  }

  .list-item-enter-active, .list-item-leave-active {
    transition: opacity 0.3s, transform 0.3s;
    transform-origin: left center;
  }

  .list-item-enter, .list-item-leave-to /* .list-leave-active for <2.1.8 */
  {
    opacity: 0;
    transform: scale(0.5);
  }

</style>



// WEBPACK FOOTER //
// src/components/otherComponents/drunkDrinks.vue